import { render } from "./DetailsModal.vue?vue&type=template&id=23c2bfcd&ts=true"
import script from "./DetailsModal.vue?vue&type=script&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__